import { Navigate, useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
// layouts
import DashboardLayout from './layouts/dashboard';
// pages
import Blog from './pages/Blog';
import ResourceType from './pages/resource-type';
import Resource from './pages/resources';
import SeeResource from './pages/resources/see-resource';
import Items from './pages/items';
import Flows from './pages/flows';
import Login from './pages/login';
import ForgotPassword from './pages/forgot-password';
import AcceptInvitation from './pages/accept-invitation';
import ResetPasswordAccept from './pages/reset-password-accept';
import Reset2FA from './pages/reset-2fa';
import Reset2FAAccept from './pages/reset-2fa-accept';
import Setup2FA from './pages/setup-2fa';
import NotFound from './pages/Page404';
import Register from './pages/Register';
import DashboardApp from './pages/dashboard';
import Credits from './pages/credits';
import User from './pages/users';
import Permissions from './pages/permissions';
import Inspections from './pages/inspections';
import SeeInspection from './pages/inspections/see-inspection';
import LocalStorage from "./utils/storage";

// ----------------------------------------------------------------------
const STORAGE_KEY_PREFIX = 'session_';

function loadSessionFromStorage(storage) {
  const key = `${STORAGE_KEY_PREFIX}current`;
  return storage.get(key, true);
}

RequireAuth.propTypes = {
  children: PropTypes.node.isRequired
};

function RequireAuth({ children }) {
  const authed = useSelector((state) => !!state.session.current) || loadSessionFromStorage(LocalStorage) !== null;
  return authed === true ? children : <Navigate to="/login" replace />;
}

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: (
        <RequireAuth>
          <DashboardLayout />
        </RequireAuth>
      ),
      children: [
        { path: 'app', element: <DashboardApp /> },
        { path: 'inspections', element: <Inspections /> },
        { path: 'inspections/:id', element: <SeeInspection /> },
        { path: 'resource-type', element: <ResourceType /> },
        { path: 'resources', element: <Resource /> },
        { path: 'resources/:id', element: <SeeResource /> },
        { path: 'items', element: <Items /> },
        { path: 'users', element: <User /> },
        { path: 'permissions', element: <Permissions /> },
        { path: 'flows', element: <Flows /> },
        { path: 'blog', element: <Blog /> },
        { path: 'credits', element: <Credits /> },
      ],
    },
    { path: '/login', element: <Login /> },
    { path: '/forgot-password', element: <ForgotPassword /> },
    { path: '/accept-invitation', element: <AcceptInvitation /> },
    { path: '/reset-password', element: <ResetPasswordAccept /> },
    { path: '/reset-2fa', element: <Reset2FA /> },
    { path: '/reset-2fa-accept', element: <Reset2FAAccept /> },
    { path: '/setup-2fa', element: <Setup2FA /> },
    { path: '/register', element: <Register /> },
    { path: '/404', element: <NotFound /> },
    { path: '/', element: <Navigate to="/dashboard/app" /> },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
  
  return routes;
}